import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19a07023"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-10 px-4 py-2" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-medium" }, "History"),
  /*#__PURE__*/_createElementVNode("p", {
    class: "text-sm mt-4",
    style: {"color":"#676767"}
  }, " The following display shows your attempted transactions which may fail or are pending. You can also view your donation history and the history of NFT received from your donation here. ")
], -1))
const _hoisted_2 = { class: "flex-1 flex flex-col px-4" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Donation Amount")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Series ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7V4.9875C5.5 4.84583 5.45217 4.72917 5.3565 4.6375C5.2605 4.54583 5.14167 4.5 5 4.5C4.85833 4.5 4.73967 4.54783 4.644 4.6435C4.548 4.7395 4.5 4.85833 4.5 5V7.0125C4.5 7.15417 4.548 7.27083 4.644 7.3625C4.73967 7.45417 4.85833 7.5 5 7.5ZM5 3.5C5.14167 3.5 5.2605 3.452 5.3565 3.356C5.45217 3.26033 5.5 3.14167 5.5 3C5.5 2.85833 5.45217 2.7395 5.3565 2.6435C5.2605 2.54783 5.14167 2.5 5 2.5C4.85833 2.5 4.73967 2.54783 4.644 2.6435C4.548 2.7395 4.5 2.85833 4.5 3C4.5 3.14167 4.548 3.26033 4.644 3.356C4.73967 3.452 4.85833 3.5 5 3.5ZM5 10C4.30833 10 3.65833 9.86867 3.05 9.606C2.44167 9.34367 1.9125 8.9875 1.4625 8.5375C1.0125 8.0875 0.656333 7.55833 0.394 6.95C0.131333 6.34167 0 5.69167 0 5C0 4.30833 0.131333 3.65833 0.394 3.05C0.656333 2.44167 1.0125 1.9125 1.4625 1.4625C1.9125 1.0125 2.44167 0.656167 3.05 0.3935C3.65833 0.131167 4.30833 0 5 0C5.69167 0 6.34167 0.131167 6.95 0.3935C7.55833 0.656167 8.0875 1.0125 8.5375 1.4625C8.9875 1.9125 9.34367 2.44167 9.606 3.05C9.86867 3.65833 10 4.30833 10 5C10 5.69167 9.86867 6.34167 9.606 6.95C9.34367 7.55833 8.9875 8.0875 8.5375 8.5375C8.0875 8.9875 7.55833 9.34367 6.95 9.606C6.34167 9.86867 5.69167 10 5 10Z",
      fill: "#6D7380"
    })
  ])
], -1))
const _hoisted_6 = { class: "font-medium" }
const _hoisted_7 = { class: "text-gray-info text-xs" }
const _hoisted_8 = { class: "flex flex-col items-start" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "inline-flex items-center text-gray-description text-sm" }
const _hoisted_11 = { class: "ml-2 leading-6" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "text-14 text-center" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Name")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Receiving address ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Amount")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Transaction ID ")
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "flex items-center space-x-2" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "font-medium" }
const _hoisted_22 = { class: "text-gray-info text-xs" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "whitespace-nowrap text-center" }
const _hoisted_25 = ["href"]

import { computed, ref, watch, onMounted } from 'vue';
import Moralis from 'moralis';
import { Icon } from '@iconify/vue';
import { PageInfo } from '@/types/Forest';
import { useUserStore } from '@/store/user';
import BaseBox from '@/components/Base/BaseBox.vue';
import ListGrouped from '@/components/ListGrouped.vue';
import {
  BSC_SCAN_URL,
  BSC_ADDRESS_URL,
  CHAIN_BLOCK_EXPLORER_URL,
  CARBON_ADDRESS,
  BIODIVERSITY_ADDRESS,
} from '@/constants';
import type { Donate } from '@/types/Donate';
import BaseMasked from '@/components/Base/BaseMasked.vue';
import { roundNumber } from '@/utils/numbers';
import useMoralis from '@/composables/useMoralis';
import Popper from 'vue3-popper';
import { displayGroupTitle } from '@/utils/dates';
import { numberWithCommas } from '@/composables/format';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const moralis = useMoralis();
const user = useUserStore();
const tabs = [
  { title: 'Donations' },
  { title: 'NFTs Transfers' },
  { title: 'Tokens Transfers' },
];
const tab = ref<number>(0);
const pageInfomation = ref<PageInfo>({
  count: 0,
  totalPage: 0,
  page: 1,
  size: 20,
});
const activities = ref<Donate[]>([]);

const isEmpty = computed(() => !activities.value.length);
const isLoading = ref<boolean>(true);

onMounted(() => {
  window.addEventListener('scroll', onScroll);
});

function onScroll() {
  const totalHeight = document.body.scrollHeight;
  const visibleHeight = window.innerHeight;
  const scrolledFromTop = window.scrollY;
  const isAtBottom = totalHeight - (visibleHeight + scrolledFromTop) <= 20;

  if (
    isAtBottom &&
    pageInfomation.value.page < pageInfomation.value.totalPage
  ) {
    getActivities();
  }
}

const getActivities = async () => {
  const [currentTab, currentUser] = [tab.value, user];
  if (!currentUser.ethAddress) return;
  const cloudFunctions = [
    'getDonationActivities',
    'getNFTTransferActivities',
    'getTokenTransferActivities',
  ];

  try {
    const res = await moralis.currect.Cloud.run(cloudFunctions[currentTab], {
      walletAddress: currentUser.ethAddress,
      page: pageInfomation.value.page,
      reverse: 'true',
      sort: 'createdAt',
    });
    pageInfomation.value = res.pageInfo;
    activities.value.push(...res.entities);
    pageInfomation.value.page++;
    setTimeout(() => {
      isLoading.value = false;
    }, 100);
  } catch (err) {
    moralis.handleMoralisError(err as Moralis.Error);
  }
};

watch(
  [tab, user],
  async () => {
    activities.value = [];
    pageInfomation.value.page = 1;
    getActivities();
  },
  { immediate: true }
);

const spliceDot = (str: string) => {
  return str.slice(0, 21) + '...';
};

const getTokenName = (addr: string) => {
  switch (addr) {
    case CARBON_ADDRESS:
      return 'Carbon tokens';
    case BIODIVERSITY_ADDRESS:
      return 'Life tokens';
    default:
      return '';
  }
};
const getTokenImage = (addr: string) => {
  switch (addr) {
    case CARBON_ADDRESS:
      return require('@/assets/carbon-tokens.svg');
    case BIODIVERSITY_ADDRESS:
      return require('@/assets/life-tokens.svg');
    default:
      return '';
  }
};
const getBSCScanURL = (tx: string) => BSC_SCAN_URL + tx;
const getBSCAddressURL = (addr: string) => BSC_ADDRESS_URL + addr;
const groupBy = (item: Record<string, string>) => {
  return displayGroupTitle(item.blockTimestamp);
};
const sorter = (a: string | number, b: string | number) => {
  return new Date(b).getTime() - new Date(a).getTime();
};

const displayDateTimeUTC = (date: string) => {
  const d = new Date(date);

  const timezone = d.getTimezoneOffset() / -60;
  return `${d.getDate() < 10 ? '0' + d.getDate() : d.getDate()}-${
    d.getMonth() + 1 < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1
  }-${d.getFullYear()}, ${
    d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
  }:${d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()}:${
    d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()
  } ${d.getHours() >= 12 ? 'PM' : 'AM'} ${
    timezone > 0 ? '+' + timezone : timezone
  } UTC`;
};
const isOwnedUser = (address: string) =>
  new RegExp(address, 'i').test(user.ethAddress as string);

return (_ctx: any,_cache: any) => {
  const _component_BaseTabs = _resolveComponent("BaseTabs")!
  const _component_BaseTableColumn = _resolveComponent("BaseTableColumn")!
  const _component_BaseTable = _resolveComponent("BaseTable")!
  const _component_BaseEmpty = _resolveComponent("BaseEmpty")!

  return (_openBlock(), _createBlock(BaseBox, {
    "box-style": "raised",
    class: "min-h-full flex flex-col"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BaseTabs, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
          tabs: tabs
        }, null, 8, ["modelValue"]),
        (isLoading.value || !_unref(isEmpty))
          ? (_openBlock(), _createBlock(ListGrouped, {
              key: 0,
              items: activities.value,
              "group-by": groupBy,
              sorter: sorter
            }, {
              header: _withCtx(({ key }) => [
                _createTextVNode(_toDisplayString(_unref(displayGroupTitle)(key)), 1)
              ]),
              default: _withCtx(({ items }) => [
                (tab.value === 0)
                  ? (_openBlock(), _createBlock(_component_BaseTable, {
                      key: 0,
                      source: items,
                      "key-by": "id",
                      "is-loading": isLoading.value
                    }, {
                      value: _withCtx(({ data, item }: { data: string, item: Donate }) => [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(numberWithCommas)(_unref(roundNumber)(parseFloat(data)))) + " " + _toDisplayString(item.currency), 1),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(displayDateTimeUTC(item.blockTimestamp)), 1)
                      ]),
                      recipient: _withCtx(({ data: recipient }) => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("a", {
                            href: `${_unref(CHAIN_BLOCK_EXPLORER_URL)}/address/${recipient}`,
                            class: "text-sm text-blue-link",
                            target: "__blank"
                          }, [
                            _createVNode(BaseMasked, {
                              first: 11,
                              last: 10
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(recipient), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ], 8, _hoisted_9),
                          _createElementVNode("div", _hoisted_10, [
                            (isOwnedUser(recipient))
                              ? (_openBlock(), _createBlock(_unref(Icon), {
                                  key: 0,
                                  icon: "bxs:wallet"
                                }))
                              : (_openBlock(), _createBlock(_unref(Icon), {
                                  key: 1,
                                  icon: "fluent:more-circle-32-filled"
                                })),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(isOwnedUser(recipient) ? 'My wallet' : 'Another address'), 1)
                          ])
                        ])
                      ]),
                      transactionHash: _withCtx(({ data }) => [
                        _createElementVNode("a", {
                          href: getBSCScanURL(data.toString()),
                          class: "text-sm text-blue-link",
                          target: "__blank"
                        }, [
                          _createVNode(BaseMasked, {
                            first: 11,
                            last: 10
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ], 8, _hoisted_12)
                      ]),
                      round: _withCtx(({ item }) => [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(item.round), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_BaseTableColumn, {
                          id: "value",
                          width: "80%"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_BaseTableColumn, {
                          id: "round",
                          width: "20%",
                          style: {"text-align":"center"}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4,
                            _createVNode(_unref(Popper), {
                              arrow: "",
                              content: " “Series” is the term used to denote a specific period of\n                  donation. Each series will cover a span of one year. For this\n                  reason, it should be noted that each NFT icon generated from\n                  different series will vary accordingly.",
                              placement: "top"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["source", "is-loading"]))
                  : (_openBlock(), _createBlock(_component_BaseTable, {
                      key: 1,
                      "key-by": "transactionHash",
                      source: items
                    }, {
                      image: _withCtx(({ item }) => [
                        _createElementVNode("img", {
                          class: "mx-auto",
                          src: item.nftImageURL || getTokenImage(item.tokenAddress),
                          alt: "",
                          style: { 'max-width': '60px' }
                        }, null, 8, _hoisted_18)
                      ]),
                      description: _withCtx(({ item }) => [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("img", {
                            class: "sm:hidden",
                            src: item.nftsImageURL || getTokenImage(item.tokenAddress),
                            alt: "",
                            style: { 'max-width': '40px' }
                          }, null, 8, _hoisted_20),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(item.nftDescription || getTokenName(item.tokenAddress)), 1),
                            _createElementVNode("div", _hoisted_22, _toDisplayString(displayDateTimeUTC(item.blockTimestamp)), 1)
                          ])
                        ])
                      ]),
                      receiving: _withCtx(({ item }) => [
                        _createElementVNode("a", {
                          href: getBSCAddressURL(item.toAddress),
                          class: "text-sm text-blue-link",
                          target: "__blank"
                        }, _toDisplayString(spliceDot(`${item.toAddress}`)), 9, _hoisted_23)
                      ]),
                      amount: _withCtx(({ item }) => [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(item.nftAmount || item.value) + " " + _toDisplayString(item.nftsName || getTokenName(item.tokenAddress)), 1)
                      ]),
                      transaction: _withCtx(({ item }) => [
                        _createElementVNode("a", {
                          href: getBSCScanURL(item.transactionHash.toString()),
                          class: "text-sm text-blue-link",
                          target: "__blank"
                        }, _toDisplayString(spliceDot(item.transactionHash.toString())), 9, _hoisted_25)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_BaseTableColumn, {
                          id: "image",
                          mobilehidden: true
                        }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_BaseTableColumn, {
                          id: "description",
                          width: "80%"
                        }),
                        _createVNode(_component_BaseTableColumn, { id: "receiving" }, {
                          default: _withCtx(() => [
                            _hoisted_15
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_BaseTableColumn, { id: "amount" }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_BaseTableColumn, { id: "transaction" }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["source"]))
              ]),
              _: 1
            }, 8, ["items"]))
          : (_unref(isEmpty))
            ? (_openBlock(), _createBlock(_component_BaseEmpty, {
                key: 1,
                src: require('@/assets/svg/empty-activity.svg'),
                class: "flex-1",
                title: "Activity not found",
                description: "Donate, claim tokens activity will be displayed here."
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})